<div class="map-wrapper">
  <div class="map" #mapViewNode></div>

  <div
    class="skiptranslate"
    id="hoverBox"
    [ngStyle]="{
      color: color,
      backgroundColor: background,
      fontSize: fontSize + 'px',
      fontWeight
    }"
  >
    {{ hoveredDevelopmentName }}
  </div>
</div>
